export const ka = {
  header: {
    title: 'ექიმი ფუტკარაძე',
  },
  nav: {
    about: 'ექიმის შესახებ',
    gallery: 'გალერეა',
    services: 'სერვისები',
    education: 'საგანმანათლებლო რესურსები',
    news: 'სიახლეები',
    askDoctor: 'შეეკითხეთ ექიმს',
    contact: 'კონტაქტი'
  },
  gallery: {
    title: 'გალერეა',
    subtitle: 'ფოტოები ჩვენი სამედიცინო პრაქტიკიდან',
  },
  news: {
    title: 'სიახლეები',
    subtitle: 'უახლესი განახლებები და სტატიები ექიმ ფუტკარაძისგან',
    readMore: 'ვრცლად',
    backToNews: 'სიახლეებზე დაბრუნება',
    publishedOn: 'გამოქვეყნდა',
    noPosts: 'სიახლეები ჯერ არ არის.',
    admin: {
      title: 'სიახლეების მართვა',
      subtitle: 'შექმენით და მართეთ სიახლეები',
      totalPosts: 'სულ პოსტები',
      published: 'გამოქვეყნებული',
      drafts: 'მონახაზები',
      createPost: 'პოსტის შექმნა',
      editPost: 'პოსტის რედაქტირება',
      deletePost: 'პოსტის წაშლა',
      deleteConfirm: 'დარწმუნებული ხართ, რომ გსურთ ამ პოსტის წაშლა?',
      form: {
        titleEn: 'სათაური (ინგლისური)',
        titleKa: 'სათაური (ქართული)',
        titleRu: 'სათაური (რუსული)',
        contentEn: 'კონტენტი (ინგლისური)',
        contentKa: 'კონტენტი (ქართული)',
        contentRu: 'კონტენტი (რუსული)',
        image: 'გამორჩეული სურათი',
        uploadImage: 'სურათის ატვირთვა',
        changeImage: 'სურათის შეცვლა',
        removeImage: 'სურათის წაშლა',
        publish: 'გამოქვეყნება',
        saveDraft: 'მონახაზად შენახვა',
        cancel: 'გაუქმება',
        save: 'შენახვა',
        publishing: 'ქვეყნდება...',
        saving: 'ინახება...'
      }
    }
  },
  education: {
    title: 'საგანმანათლებლო რესურსები',
    subtitle: 'შერჩეული კონტენტი ტრავმატოლოგიისა და ორთოპედიის უკეთ გასაგებად',
    georgian: {
      title: 'საგანმანათლებლო რესურსები ქართულ ენაზე',
      watchVideo: 'ვიდეოს ნახვა'
    },
    english: {
      title: 'საგანმანათლებლო რესურსები ინგლისურ ენაზე',
      watchVideo: 'ვიდეოს ნახვა'
    },
    russian: {
      title: 'საგანმანათლებლო რესურსები რუსულ ენაზე',
      watchVideo: 'ვიდეოს ნახვა'
    }
  },
  hero: {
    title: 'ექიმი გიორგი ფუტკარაძე',
    subtitle: 'აღიარებული სპეციალისტი ტრავმა-ორთოპედიის დარგში',
    cta: 'ჩაეწერეთ ვიზიტზე',
  },
  about: {
    sectionTitle: 'სამედიცინო გამოცდილება',
    certifiedSpecialist: 'სერტიფიცირებული სპეციალისტი',
    aoMethodology: 'AO მეთოდოლოგია',
    internationalStandards: 'საერთაშორისო სტანდარტები',
  },
  stats: {
    childbirths: {
      number: '5,000+',
      text: 'წარმატებული ოპერაცია',
    },
    complications: {
      number: '2,500+',
      text: 'სახსრის ხელოვნური ჩანაცვლება',
    },
    surgeries: {
      number: '1,000+',
      text: 'გართულებული შემთხვევის რე-იმპლანტაცია',
    },
    experience: {
      number: '10+',
      text: 'წლიანი გამოცდილება',
    },
  },
  expertise: {
    title: 'ექსპერტ სფეროები და სპეციალიზაცია',
    subtitle: 'მრავალწლიანი გამოცდილება ტრავმა-ორთოპედიის დარგში, ექიმმა გიორგი ფუტკარაძემ წარმატებით უმკურნალა ათასობით პაციენტს როგორც კონსერვატიულად ისე რთული ქირურგიული ჩარევით.',
    services: {
      obstetrics: {
        title: 'ტრავმატოლოგიური მომსახურება',
        description: 'დიაგნოსტიკა და მკურნალობა AO მეთოდური მითითებების შესაბამისად: ძვლების მოტეხილობები, ამოვარდნილობები, დაჭიმულობები, იოგებისა და მყესების დაზიანებები — როგორც საყოფაცხოვრებო, ისე სპორტული ტრავმების დროს.',
      },
      surgery: {
        title: 'ორთოპედიული მომსახურება',
        description: 'ართროზი, ართრიტი, სახსრების ტკივილი, მოძრაობის შეზღუდვა, ანთებითი და დეგენერაციული პროცესების შეფასება და მკურნალობა, ყველა მსხვილი სახსრის ენდოპროთეზირება.',
      },
      health: {
        title: 'გართულებული შემთხვევების მართვა',
        description: 'რეკონსტრუქციული ქირურგია განმეორებითი სარევიზიო რეიმპლანტაციის გამოყენებით.',
      },
      additional: {
        title: 'კონსერვატიული მკურნალობა',
        description: 'იმობილიზაცია, ინექციური თერაპია, ფიზიკური დატვირთვის სწორად დაგეგმვა, რეაბილიტაციისა და აღდგენის ინდივიდუალური პროგრამების შედგენა.',
      },
    },
  },
  contact: {
    title: 'საკონტაქტო ინფორმაცია',
    subtitle: 'დაჯავშნეთ ვიზიტი ან დაგვიკავშირდით ნებისმიერი შეკითხვით.',
    getInTouch: 'დაგვიკავშირდით',
    mobile: 'მობილური',
    office: 'ოფისი',
    currentWorkplaces: 'მიმდინარე სამუშაო ადგილები',
    phone: '+995 596 09 10 00',
    landline: '',
    email: 'futkaradzegiorgi@gmail.com',
    clinics: {
      openHeart: 'ბათუმის სამედიცინო ცენტრო (ბათუმი)',
      barbara: 'ნურალიძე უნიქალმედი (ქუთაისი)'
    },
    hours: 'ორშაბათი - პარასკევი: 9:00 - 18:00',
    appointments: 'ვიზიტები ხელმისაწვდომია',
  },
  footer: {
    copyright: '© {year} ექიმი გიორგი ფუტკარაძე. ყველა უფლება დაცულია.',
  },
  aiChat: {
    title: 'AI სამედიცინო ასისტენტი',
    backToHome: 'მთავარ გვერდზე დაბრუნება',
    description: 'AI ასისტენტი დაგეხმარებათ:',
    capabilities: {
      general: 'ზოგადი სამედიცინო ინფორმაცია და გაიდლაინები',
      symptoms: 'გავრცელებული სიმპტომები და მდგომარეობები',
      recommendations: 'ძირითადი ჯანმრთელობის რეკომენდაციები',
      pregnancy: 'ტრავმატოლოგია და ორთოპედიის ინფორმაცია'
    },
    disclaimer: 'გთხოვთ გაითვალისწინოთ: AI გაწვდით მხოლოდ ზოგად ინფორმაციას და არ ჩაანაცვლებს პროფესიონალურ სამედიცინო რჩევას.',
    askDoctor: {
      title: 'შეეკითხეთ ექიმს',
      description: 'გაქვთ კონკრეტული შეკითხვა? დატოვეთ თქვენი შეკითხვა აქ და ექიმი პირადად განიხილავს და უპასუხებს თქვენს მოთხოვნას სამუშაო საათებში. შეგიძლიათ დაურთოთ შესაბამისი სამედიცინო დოკუმენტები, რაც დაეხმარება ექიმს უკეთ გაიგოს თქვენი მდგომარეობა.',
      instructions: {
        title: 'როგორ დავსვათ შეკითხვა',
        steps: 'მიუთითეთ თქვენი საკონტაქტო ინფორმაცია\nდაწერეთ თქვენი შეკითხვა დეტალურად\nდაურთეთ შესაბამისი სამედიცინო დოკუმენტები (არასავალდებულო)\nგააგზავნეთ შეკითხვა და დაელოდეთ პასუხს ელ-ფოსტაზე'
      },
      attachments: {
        title: 'დამხმარე დოკუმენტები',
        description: 'შეგიძლიათ დაურთოთ შესაბამისი სამედიცინო დოკუმენტები:',
        voice: {
          title: 'ხმის ჩაწერა',
          description: 'შეგიძლიათ ჩაიწეროთ თქვენი ხმა კითხვის დეტალურად ასახსნელად',
          start: 'ჩაწერის დაწყება',
          stop: 'ჩაწერის შეწყვეტა',
          delete: 'ჩანაწერის წაშლა',
          duration: 'ჩანაწერის ხანგრძლივობა: {seconds} წამი',
          instructions: 'დააჭირეთ ხმოვანი შეტყობინების ჩასაწერად. ისაუბრეთ გარკვევით და დეტალურად აღწერეთ თქვენი სამედიცინო პრობლემა.'
        },
        types: 'ლაბორატორიული ანალიზების შედეგები\nსამედიცინო გამოსახულებების დასკვნები\nწინა სამედიცინო ჩანაწერები\nრეცეპტების დოკუმენტები',
        limits: 'მისაღები ფორმატები: სურათები, PDF, DOC. მაქსიმალური ზომა: 10MB თითო ფაილზე',
        button: 'დოკუმენტების დამატება',
        remove: 'წაშლა'
      },
      emailNote: 'პასუხს მიიღებთ ელ-ფოსტაზე',
      namePlaceholder: 'თქვენი სახელი',
      emailPlaceholder: 'თქვენი ელ-ფოსტა',
      phonePlaceholder: 'ტელეფონი (არასავალდებულო)',
      label: 'თქვენი შეკითხვა',
      placeholder: 'ჩაწერეთ თქვენი შეკითხვა აქ...',
      submit: 'შეკითხვის გაგზავნა',
      error: 'შეკითხვის გაგზავნისას მოხდა შეცდომა. გთხოვთ სცადოთ ხელახლა.',
      success: {
        title: 'მადლობა თქვენი შეკითხვისთვის!',
        message: 'ექიმი განიხილავს და უპასუხებს თქვენს მოთხოვნას ელ-ფოსტით რაც შეიძლება მალე.',
        askAnother: 'დასვით სხვა შეკითხვა'
      }
    }
  },
  askDoctor: {
    form: {
      namePlaceholder: 'თქვენი სახელი',
      emailPlaceholder: 'თქვენი ელ-ფოსტა'
    }
  },
  chat: {
    title: 'AI სამედიცინო ასისტენტი',
    subtitle: 'მიიღეთ ექსპერტული სამედიცინო რჩევები 24/7',
    disk: {
      medicalAssistance: 'სამედიცინო დახმარება',
      healthGuidance: 'ჯანმრთელობის გზამკვლევი',
      expertSupport: 'ექსპერტის მხარდაჭერა',
      available: '24/7 ხელმისაწვდომი'
    },
    welcome: 'დამისვით ნებისმიერი სამედიცინო შეკითხვა',
    placeholder: 'დაწერეთ თქვენი შეკითხვა...',
    error: 'ბოდიში, მაგრამ დაკავშირება ვერ ხერხდება. გთხოვთ სცადოთ ხელახლა.',
    online: 'ონლაინ',
    typing: 'წერს...',
    thinking: 'ფიქრობს...',
    inputAriaLabel: 'შეტყობინების შეყვანა',
    sendAriaLabel: 'შეტყობინების გაგზავნა',
    quickReplies: {
      appointments: 'როგორ დავჯავშნო ვიზიტი?',
      services: 'რა სერვისებს გთავაზობთ?',
      location: 'სად მდებარეობს თქვენი კლინიკა?'
    }
  },
  admin: {
    portal: 'ადმინ პორტალი',
    login: 'ადმინისტრატორის შესვლა',
    signIn: 'შესვლა',
    signingIn: 'შესვლა...',
    email: 'ელფოსტა',
    password: 'პაროლი',
    backToHome: 'მთავარ გვერდზე დაბრუნება',
    signInSubtitle: 'შედით ადმინისტრატორის პანელზე წვდომისთვის',
    authError: 'ავთენტიფიკაციის შეცდომა',
    accessInfo: 'მხოლოდ ავტორიზებულ პერსონალს აქვს წვდომა ამ სივრცეზე. თუ წვდომა გჭირდებათ, დაუკავშირდით სისტემის ადმინისტრატორს.'
  },
  chatHistory: {
    backToChat: 'ჩატზე დაბრუნება',
    title: 'ჩატის ისტორია',
    noConversations: 'წინა საუბრები არ მოიძებნა.',
    view: 'ნახვა',
    delete: 'წაშლა',
    deleteConfirmation: 'დარწმუნებული ხართ, რომ გსურთ ამ საუბრის წაშლა? ეს მოქმედება ვერ გაუქმდება.'
  },
  response: {
    respondToPatient: 'პაციენტისთვის პასუხი',
    patientQuestion: 'პაციენტის კითხვა:',
    aiResponse: 'AI გენერირებული პასუხი:',
    placeholder: 'დაწერეთ ან შეცვალეთ თქვენი პასუხი აქ...',
    downloadPdf: 'PDF ჩამოტვირთვა',
    cancel: 'გაუქმება',
    send: 'გაგზავნა'
  },
  email: {
    title: 'სამედიცინო პასუხი - დოქტორი პუტკარაძე',
    header: 'დოქტორ პუტკარაძის სამედიცინო პლატფორმა',
    subheader: 'პროფესიონალური სამედიცინო კონსულტაციის პასუხი',
    patientInfo: 'პაციენტის ინფორმაცია',
    yourQuestion: 'თქვენი კითხვა',
    medicalResponse: 'სამედიცინო პასუხი',
    footer: 'პროფესიონალური ჯანდაცვის საკონსულტაციო სერვისები',
    generated: 'გამოგზავნილია'
  },
  locations: {
    tbilisiGeorgia: 'თბილისი, საქართველო'
  },
  adminGuidelines: {
    title: 'როგორ ვუპასუხოთ',
    subtitle: 'მიჰყევით ამ ნაბიჯებს პაციენტის კითხვაზე პასუხის გაცემისას',
    steps: {
      step1: 'წაიკითხეთ კითხვა და დანართები',
      step2: 'გამოიყენეთ AI ასისტენტი საჭიროების შემთხვევაში',
      step3: 'დააჭირეთ "პასუხი" ღილაკს',
      step4: 'დაწერეთ ან შეცვალეთ პასუხი',
      step5: 'დააჭირეთ "გაგზავნა" პაციენტისთვის გასაგზავნად'
    },
    collapse: 'დამალვა',
    expand: 'ჩვენება'
  }
};